<template>
  <div id="Users">
    <MyBanner
      :text="$t('banner.accessDcPage')"
      v-if="$t('banner.accessDcPage') != ''"
    />
    <MyHeaderPage
      :title="$t('reports.current.title')"
      :subtitle="$t('reports.current.subTitle')"
    />
    <br /><br />
    <div id="TicketsList">
      <div class="listTicket">
        <!-- FILTRO -->
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="filterTickets">
              <div class="contentInputFilter">
                <div class="contentIcon">
                  <span class="material-icons">search</span>
                </div>
                <div class="contentInput">
                  <input
                    type="text"
                    :placeholder="$t('actions.text_search_placeholder')"
                    v-model="searchString"
                    @keyup="searchByString"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="dateFrom"
                class="not-empty"
                v-model="dateFrom"
                style="background-color: white"
                @change="getList()"
              />
              <label>{{ $t("reports.filter.dateFrom") }}</label>
              <span
                class="error"
                v-if="this.v$.dateFrom.$invalid && this.v$.dateFrom.$dirty"
              >
                {{ $t("reports.filter.dateFrom") }}
                {{ $t("reports.filter.isRequired") }}
              </span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="dateTo"
                class="not-empty"
                v-model="dateTo"
                style="background-color: white"
                @change="getList()"
              />
              <label>{{ $t("reports.filter.dateTo") }}</label>
              <span
                class="error"
                v-if="this.v$.dateTo.$invalid && this.v$.dateTo.$dirty"
              >
                {{ $t("reports.filter.dateTo") }}
                {{ $t("reports.filter.isRequired") }}
              </span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <button
              class="cdlButton"
              @click="exportCsv"
              :disabled="!viewLoader || isExporting"
            >
              <img src="@/assets/img/download.png" alt="icon" />
              {{ $t("users.downLoadCSV") }}
            </button>
          </div>
        </div>
        <!-- FINE FILTRO -->

        <div class="mdl-grid currentLegend" v-if="pagedItems.length > 0">
          <div class="mdl-cell mdl-cell--12-col">
            <h3 class="titleH3">{{ $t("reports.current.titleLegend") }}</h3>
            <br />
            <div v-html="$t('reports.current.textLegend')"></div>
          </div>
        </div>

        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--12-col">
            <br />
            <ReportTable
              :items="itemFilter"
              :loading="viewLoader"
              :empty-colspan="$IsMobile() ? 1 : 4"
            >
              <template #header>
                <tr>
                  <th v-if="!$IsMobile()">
                    {{ $t("reports.current.col.colOne") }}
                  </th>
                  <th>{{ $t("reports.current.col.colTwo") }}</th>
                  <th v-if="!$IsMobile()">
                    {{ $t("reports.current.col.colThree") }}
                  </th>
                </tr>
              </template>

              <template #row="{ item, index }">
                <tr :class="{ odd: index % 2 }">
                  <td>{{ item.data }}</td>
                  <td v-if="!$IsMobile()">
                    {{ $t("reports.current.month." + item.data.split("-")[1]) }}
                    {{ item.data.split("-")[0] }}
                  </td>
                  <td>{{ item.tipo }}</td>
                  <td v-if="!$IsMobile()">
                    <div class="cdlButton" @click="download(item.url)">
                      {{ $t("reports.current.download") }}
                    </div>
                  </td>
                </tr>
              </template>

              <template #mobile="{ item }">
                <MobileRow :cols="['data', 'tipo']" :item="item">
                  <template #url-label>
                    <div class="cdlButton" @click="download(item.url)">
                      {{ $t("reports.current.download") }}
                    </div>
                  </template>
                </MobileRow>
              </template>
            </ReportTable>
            <Paginator
              v-if="viewLoader && totalItems > 0"
              :total-page="paginatedItems"
              :current-page="currentPage"
              :itemsPerPage="itemsPerPage"
              @prev-page="beforePage"
              @next-page="nextPage"
              @change-page="changePage"
            />
          </div>
        </div>

        <div class="mdl-grid currentLegend" v-if="pagedItems.length > 0">
          <div class="mdl-cell mdl-cell--12-col">
            <div class="titleH3">
              {{ $t("reports.current.titleLegendExel") }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <p class="label">{{ $t("reports.current.typeFile") }}: Summary</p>
            <ul>
              <li>
                <strong>datacenter:</strong>
                {{ $t("reports.current.ConsumiEnergiaDatacenter") }}
              </li>
              <li>
                <strong>island:</strong>
                {{ $t("reports.current.ConsumiEnergiaIsland") }}
              </li>
              <li>
                <strong>rack_id:</strong>
                {{ $t("reports.current.ConsumiEnergiaRackId") }}
              </li>
              <li>
                <strong>rack_name:</strong>
                {{ $t("reports.current.ConsumiEnergiaRackName") }}
              </li>
              <li>
                <strong>ampere:</strong>
                {{ $t("reports.current.ConsumiEnergiaAmpere") }}
              </li>
            </ul>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <p class="label">{{ $t("reports.current.typeFile") }}: Details</p>
            <ul>
              <li>
                <strong>datacenter:</strong>
                {{ $t("reports.current.ConsumiEnergiaDatacenter") }}
              </li>
              <li>
                <strong>island:</strong>
                {{ $t("reports.current.ConsumiEnergiaIsland") }}
              </li>
              <li>
                <strong>rack_id:</strong>
                {{ $t("reports.current.ConsumiEnergiaRackId") }}
              </li>
              <li>
                <strong>rack_name:</strong>
                {{ $t("reports.current.ConsumiEnergiaRackName") }}
              </li>
              <li>
                <strong>rack_socket_id:</strong>
                {{ $t("reports.current.ConsumiEnergiaSocketId") }}
              </li>
              <li>
                <strong>magnetotermico:</strong>
                {{ $t("reports.current.ConsumiEnergiaMagnetotermico") }}
              </li>
              <li>
                <strong>date:</strong>
                {{ $t("reports.current.ConsumiEnergiaDate") }}
              </li>
              <li>
                <strong>ampere:</strong>
                {{ $t("reports.current.ConsumiEnergiaAmpere") }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyBanner from "@/components/MyBanner.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import MobileRow from "@/components/Tables/MobileRow.vue";
import ReportTable from "@/components/Reports/ReportTable.vue";
import Paginator from "@/components/Paginator.vue";
import "@/assets/scss/TicketsList.scss";
import moment from "moment";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "CCurrent",
  components: {
    MyBanner,
    MyHeaderPage,
    MobileRow,
    ReportTable,
    Paginator,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      dateFrom: { required },
      dateTo: { required },
    };
  },
  data() {
    return {
      viewLoader: false,
      items: [],
      itemFilter: [],
      currentPage: 1,
      itemsPerPage: 10,
      paginatedItems: 0,
      totalItems: 0,
      isExporting: false,
      // items: [
      //   {
      //       "id": 2947,
      //       "customer_id": 328,
      //       "data": "2023-08-31",
      //       "tipo": "Colo: ampere details",
      //       "url": "https://allegati.s3.cloudlan.it/50028a9c-9566-4377-a29f-ecbb0ba39b1b-202308-details.csv",
      //       "uploaded": 1
      //   },
      //   {
      //       "id": 2947,
      //       "customer_id": 328,
      //       "data": "2024-08-31",
      //       "tipo": "Colo: ciccio details",
      //       "url": "https://allegati.s3.cloudlan.it/50028a9c-9566-4377-a29f-ecbb0ba39b1b-202308-details.csv",
      //       "uploaded": 1
      //   }
      // ],
      // itemFilter: [
      //   {
      //       "id": 2947,
      //       "customer_id": 328,
      //       "data": "2023-08-31",
      //       "tipo": "Colo: ampere details",
      //       "url": "https://allegati.s3.cloudlan.it/50028a9c-9566-4377-a29f-ecbb0ba39b1b-202308-details.csv",
      //       "uploaded": 1
      //   },
      //   {
      //       "id": 2947,
      //       "customer_id": 328,
      //       "data": "2024-08-31",
      //       "tipo": "Colo: ciccio details",
      //       "url": "https://allegati.s3.cloudlan.it/50028a9c-9566-4377-a29f-ecbb0ba39b1b-202308-details.csv",
      //       "uploaded": 1
      //   }
      // ],
      dateFrom: moment().subtract(6, "months").format("YYYY-MM-DD"),
      dateTo: moment().format("YYYY-MM-DD"),
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      searchString: "",
    };
  },
  methods: {
    async getList() {
      const result = await this.v$.$validate();
      if (!result) {
        return;
      }

      this.viewLoader = false;

      const dateFrom = moment(this.dateFrom, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
        "YYYY-MM-DD"
      );
      const dateTo = moment(this.dateTo, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
        "YYYY-MM-DD"
      );

      let par = "";
      if (this.itemsPerPage) {
        par += "&per_page=" + this.itemsPerPage;
      }

      if (this.searchString && this.searchString.trim() !== "") {
        par += "&search=" + this.searchString;
      }

      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "front/v1/report-power/?from=" +
            dateFrom +
            "&to=" +
            dateTo +
            "&page=" +
            this.currentPage +
            par,
          { headers: this.he }
        )
        .then((rls) => {
          if (rls.data && rls.data.data) {
            this.items = rls.data.data;
            this.currentPage = rls.data.current_page || 1;
            this.itemsPerPage = rls.data.per_page || this.itemsPerPage;
            this.totalItems = rls.data.total || this.items.length;
            this.paginatedItems = Math.ceil(this.totalItems / this.itemsPerPage);
          } else {
            this.items = rls.data || [];
            this.totalItems = this.items.length;
            this.paginatedItems =
              this.totalItems > 0
                ? Math.ceil(this.totalItems / this.itemsPerPage)
                : 0;
          }

          this.itemFilter = this.items;
          this.viewLoader = true;
        })
        .catch((err) => {
          console.error(err);
          this.viewLoader = true;
        });
    },
    searchByString() {
      this.currentPage = 1;

      if (this.searchString.length >= 3 || this.searchString.length === 0) {
        this.getList();
        return;
      }

      this.itemFilter = [];
      const elm = this.searchString.toLowerCase();
      this.items.forEach((item) => {
        const data = item.data ? item.data.toLowerCase().includes(elm) : false;
        const tipo = item.tipo ? item.tipo.toLowerCase().includes(elm) : false;
        if (data || tipo) {
          this.itemFilter.push(item);
        }
      });
    },
    download(url) {
      window.open(url, "_blank").focus();
    },
    changePage(page) {
      this.currentPage = page;
      this.getList();
    },
    beforePage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getList();
      }
    },
    nextPage() {
      if (this.currentPage < Math.ceil(this.totalItems / this.itemsPerPage)) {
        this.currentPage++;
        this.getList();
      }
    },
    exportCsv() {
      if (!this.viewLoader || this.isExporting) {
        return;
      }

      this.isExporting = true;

      const dateFrom = moment(this.dateFrom, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
        "YYYY-MM-DD"
      );
      const dateTo = moment(this.dateTo, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
        "YYYY-MM-DD"
      );

      let par = "";
      if (this.searchString && this.searchString.trim() !== "") {
        par += "&search=" + this.searchString;
      }

      const header = {
        Authorization: "Bearer " + this.$keycloak.idToken,
        Accept: "text/csv",
      };

      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "front/v1/report-power/?from=" +
            dateFrom +
            "&to=" +
            dateTo +
            "&csv=true" +
            par,
          { headers: header, responseType: "blob" }
        )
        .then((response) => {
          const blob =
            response.data instanceof Blob ? response.data : new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;

          const contentDisposition = response.headers["content-disposition"];
          let filename = "power_report.csv";

          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch && filenameMatch.length === 2) {
              filename = filenameMatch[1];
            }
          }

          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.isExporting = false;
        })
        .catch((error) => {
          console.error("Error downloading CSV:", error);
          this.isExporting = false;
        });
    },
  },
  computed: {
    pagedItems() {
      return this.itemFilter || [];
    },
    totalPages() {
      return Math.ceil(this.itemFilter.length / this.itemsPerPage);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
